export default __webpack_public_path__ + "static/media/lha-logo-square-light.82220b25.png";